// extracted by mini-css-extract-plugin
module.exports = {"table":"RecipientsTable_table__Thzx-","tableHeadCell":"RecipientsTable_tableHeadCell__ckwks"};